import React from 'react'

interface EmailSuccessProps {
  width?: number,
  height?: number
}

const EmailSuccess = ({ height = 24, width = 24 }: EmailSuccessProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path
      fill="#0076FF"
      fillRule="nonzero"
      d="M21 24H3c-1.654 0-3-1.403-3-3.13V10.435c0-.009.004-.016.005-.024.002-.08.026-.156.045-.233.006-.03.008-.058.017-.087l.007-.013a1.02 1.02 0 0 1 .092-.186c.02-.037.03-.078.056-.113.011-.014.028-.02.04-.034.006-.006.014-.01.019-.017.019-.02.026-.047.046-.065l3.276-3.108a.97.97 0 0 1 1.413.07 1.075 1.075 0 0 1-.068 1.473l-2.412 2.289 5.73 4.823 2.71-2.317a1.604 1.604 0 0 1 2.04-.008l2.718 2.325 5.729-4.822-2.39-2.269a1.076 1.076 0 0 1-.07-1.473.971.971 0 0 1 1.413-.071l3.256 3.088c.02.018.028.044.045.064.007.007.014.01.02.018.013.014.03.02.04.034.028.036.037.077.058.114.036.06.068.12.091.184l.007.014c.01.03.012.061.019.092.018.075.04.15.043.227.001.008.005.016.005.025V20.87c0 1.727-1.346 3.13-3 3.13zM1.95 12.575v8.032l4.736-4.047-4.735-3.985zM12 14.715l-8.422 7.198h16.844L12 14.715zm10.142-2.217l-4.827 4.062 4.827 4.126v-8.188zM7.775 4.38l3.363 3.48L17.402.361a.987.987 0 0 1 1.424-.108c.422.376.47 1.035.105 1.471l-6.975 8.348a.988.988 0 0 1-1.478.056L6.347 5.855a1.068 1.068 0 0 1 0-1.476.987.987 0 0 1 1.428.001z"
    />
  </svg>
)

export default EmailSuccess